import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DeleteImportDeclarationDetailRequest } from 'src/app/core/models/transport-operation/delete-import-declaration-detail-request';
import { DeleteImportDeclarationRequest } from 'src/app/core/models/transport-operation/delete-import-declaration-request';
import { ImportDeclarationDetailResponse } from '../pages/import-search/dto/import-declaration-detail';

@Injectable({
  providedIn: 'root'
})
export class ImportDeclarationService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * get Export Header
   * @param exportDeclarationNo export no
   */
   getImportHeader(importHeaderRequest: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/importHeader`;
    return this.http.post(url, importHeaderRequest);
  }

  /**
   * Get Import Header detail.
   * @param importDeclarationNo Import Declaration No.
   */
  getImportHeaderDetail(importDeclarationNo: string): Promise<any> {
    const url = `${environment.logisticsApiUrl}/importDeclaration/importHeader/${importDeclarationNo}`;
    return this.http.get(url).toPromise();
  }

  /**
   * get Export Detail By ImportDeclarationNo
   * @param exportDeclarationNo export no
   */
  getImportDetail(importDeclarationNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/importDetail/${importDeclarationNo}`;
    return this.http.get(url);
  }

  /**
   * update import
   */
  updateImportDetail(updateObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/update/importHeader`;
    return this.http.put(url, updateObj);
  }

  /**
   * copy ImportDeclaration
   * @param copyParams
   * @returns
   */
  copyImportDeclaration(copyParams: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/copy/importDeclaration`;
    return this.http.post(url, copyParams);
  }

  confirmImportDeclaration(confirmParams: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/confirm/importDeclaration`;
    return this.http.post(url, confirmParams);
  }

  cancelImportDeclaration(cancelParams: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/cancel/importDeclaration`;
    return this.http.post(url, cancelParams);
  }

  importDetail(detailParam: any): Observable<ImportDeclarationDetailResponse>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/import/importDeclarationDetail`;
    return this.http.post<ImportDeclarationDetailResponse>(url, detailParam);
  }

  /**
   * delete Import Declaration Detail By ImportDeclarationNo and LineNo
   * @param importDeclarationNo import no
   * @param lineNo line no
   */
  deleteImportDeclarationDetail(deleteObj: DeleteImportDeclarationDetailRequest): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/delete/importDeclarationDetail`;
    return this.http.post(url, deleteObj);
  }

  /**
   * delete Import Declaration By ImportDeclarationNo
   * @param importDeclarationNo import no
   */
  deleteImportDeclaration(deleteObj: DeleteImportDeclarationRequest): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/delete/importDeclaration`;
    return this.http.post(url, deleteObj);
  }

  saveBillingBy(importDeclarationNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/saveBillingBy/${importDeclarationNo}`;
    return this.http.post(url, null);
  }

  trxNumberForDetail(importDeclarationNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/importDeclaration/trxNumber/${importDeclarationNo}`;
    return this.http.get(url);
  }
}
